module.exports = __webpack_public_path__ + "static/media/HomeHighBenefits.0c0b9c5f.svg";